module.exports = __webpack_public_path__ + "static/media/chubb.fd809a1d.webp";